import { AxiosResponse } from 'axios';
import BaseAPI from "../api";

const path: string = "/booking-meeting-room-approve";

export type listType = {
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  limit?: number;
  page?: number;
  keyword?: string;
  search?: string;
  room_meeting_type?: string;
};


export type approve_booking_meeting = {
  meeting_room_approve_type: string;
  meeting_room_approve_remark: string;
}

export type MeetingRoomCondition = {
  after_approves: boolean;
  id_meeting_room: number;
  after_approves_day: number | string;
  before_booking: boolean;
  before_booking_day: number | string;
  contract_employees: ContractEmployee[];
  file_conditions: FileCondition[];
};

export type ContractEmployee = {
  id_meeting_room_contact: number | null;
  // meeting_room_contact_type: string;
  id_employee: number | null;
  title: string;
  contact_name: string;
  contact_last_name: string;
  position: string;
  department: string;
  tel: string;
  email: string;

  // STATE FRONT END
  file_path?: string;
};

export type FileCondition = {
  id_meeting_room_file: number | null;
  file_name: string;
  file_type: string;
  file_path: string;
  file_size: string;
};


export class BookingMeetingRoomApproveApi extends BaseAPI {
  static ApproveMeetingRoomByTypeList(
    id_meeting_room: number,
    body: any
  ): Promise<AxiosResponse> {
    return this.api.post(`${path}/${id_meeting_room}/approve`, body);
  }

  static approve(
    id_meeting_room: number,
    body: approve_booking_meeting
  ): Promise<AxiosResponse> {
    return this.api.post(`${path}/${id_meeting_room}/approve`, body);
  }


  static createCondition(body: MeetingRoomCondition): Promise<AxiosResponse> {
    return this.api.post(`${path}/condition`, body)
  }
  static updateCondition(id_meeting_room: number, body: MeetingRoomCondition): Promise<AxiosResponse> {
    return this.api.patch(`${path}/${id_meeting_room}/condition`, body)
  }
  static findOneCondition(id_meeting_room: number): Promise<AxiosResponse> {
    return this.api.get(`${path}/get-one/${id_meeting_room}/condition`)
  }


}
